/**
 * @see https://github.com/greensock/GreenSock-JS/blob/master/src/uncompressed/plugins/TEMPLATE_Plugin.js
 */
namespace e5 {
    var transformPluginMatrix = new Matrix3d();
    //Check if TweenMax is available.
    if (_gsScope && _gsScope._gsDefine) {
        _gsScope._gsDefine.plugin({
            propName: "matrix3d",
            priority: 0,
            API: 2,
            version: "1.0.0",
            overwriteProps: ["transform", "x", "y", "z", "scaleX", "scaleY", "skewX", "skewY", "rotation", "rotationX", "rotationY", "rotationZ"],
            init: function (target: HTMLElement, value: Matrix3d | string, tween: any, index: number) {
                this._target = target;

                var style: CSSStyleDeclaration = tween.vars.style || window.getComputedStyle(target);
                if (typeof value === "string")
                    transformPluginMatrix.setCss(value);
                else
                    transformPluginMatrix.copyFrom(value);
                var valuesEnd: any = transformPluginMatrix.copyTo();
                this._valuesEnd = valuesEnd;

                transformPluginMatrix.setCss(style.transform);
                var valuesStart: any = transformPluginMatrix.copyTo();
                this._valuesStart = valuesStart;

                var valuesChange: any = {};
                for (var p in valuesEnd) {
                    valuesChange[p] = valuesEnd[p] - valuesStart[p];
                }
                this._valuesChange = valuesChange;
                return true;
            },

            set: function (ratio: number) {
                for (var p in this._valuesEnd) {
                    this._valuesEnd[p] = this._valuesStart[p] + this._valuesChange[p] * ratio;
                }
                transformPluginMatrix.copyFrom(this._valuesEnd);
                this._target.style.transform = transformPluginMatrix.getCss3d();
            }
        });
    }
}